/**
 * Does this account get a door to its client view?
 *
 * The CASE axis, not memberships: `uq_pm_active` allows one membership per (user, practice),
 * so a parent employed at her child's practice is support_worker on the practice axis and
 * client_contact only on the CASE — she is exactly who the door is for.
 *
 * FAILS OPEN. `some(...)` is false while loading AND after a failure, so a naive predicate
 * deletes the door on a transient error. A door to an empty portal is an annoyance; a
 * missing one strands a client from their own case.
 */
export function clientViewDoorVisible(
  input: { readonly isError: boolean; readonly cases: readonly { readonly role_in_case?: string | undefined }[] | undefined },
): boolean {
  if (input.isError) return true;
  // not-authorization: persona shell — WHICH DOOR to offer. /portal re-checks server-side,
  // and this reads a relationship the server already handed over.
  return (input.cases ?? []).some((c) => c.role_in_case === 'client_contact');
}
